import { Loader2 } from 'lucide-react';

function LoadingOpacityDialog() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50 dark:bg-black dark:bg-opacity-50">
      <div className="flex flex-col items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <p className="mt-2 text-sm text-primary">جاري التحميل</p>
      </div>
    </div>
  );
}

export default LoadingOpacityDialog;
